import React from 'react'
import Header from '../../components/header/header'

import PaidupCapitalComponent from './PaidupCapitalComponent';

export default function Paidupcapitallist() {
    return (
        <div>
            <Header />
            <div className="container-fluid">
                <PaidupCapitalComponent pageType={false} />
            </div>
        </div>
    )
}
